export function downloadCsv(data: Blob, fileName: string) {
  const blob = new Blob([data], { type: "text/csv" });

  // 仮のHTML要素を作成し、ダウンロードを実行する
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
}
